import { render } from "./TabButtons.vue?vue&type=template&id=10d41c5a"
import script from "./TabButtons.vue?vue&type=script&lang=js"
export * from "./TabButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__